<template>
  <div class="mobile-layout-design">
    <LoadingSpinner v-if="loading" />
    <div v-else>
      <CompanyLogo 
        :wizard="false"
        :show-name="false"
        :type="type"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import settingsPageSetup from "@/mixins/settingsPageSetup"
import GekkoButton from '@/components/GekkoButton.vue'
import LoadingSpinner from "@/components/dashboard/ui/LoadingSpinner"
import CompanyLogo from "@/components/wizard/steps/CompanyLogo";

export default {
  name: 'LogoGeneratorMobile',
  components: {
    GekkoButton,
    LoadingSpinner,
    CompanyLogo
  },
  mixins: [ settingsPageSetup ],
  data () {
    return {
      loading: false,
      pageSettings: {
        showCompanyPicker: false
      },
      mobile_app_view: null,
      type: 'company'
    }
  },
  computed:{
    ...mapGetters({ 
      currentCompany: "main/getCurrentCompany",
      preferredLanguage: 'main/getPreferredLanguage',
      getCompanyId: 'main/getCompanyId',
      getMobileAppView: "main/getMobileAppView"
    })
  },
  created () {
    this.mobile_app_view = this.getMobileAppView
    document.documentElement.style.setProperty('--settings-bg-color', 'white');
    this.setupData()
  },
  methods:{
    ...mapActions({
      getBrandDataAndSelect: 'brands/getBrandDataAndSelect',
    }),
    setupData () {
      if (this.$route.params.brand_id) {
        this.loading = true
        this.type = 'brand'
        this.getBrandDataAndSelect(this.$route.params.brand_id).then(() => {
          this.$nextTick(() => {
            this.loading = false
          })
        })
      }
    },
    saveChanges () {
      if (!this.currentCompany.is_premium) {
        this.$store.commit('togglePremiumModal', 'web_invoices_design')
      } else {
        this.$refs['invoicelayout-design'].saveChanges()
      }
    },
    updatedDesign () {
      console.log('updatedDesign')
    },
  }
};
</script>

<style lang="scss">
  .main-content.logogeneratormobile {
    padding: 0 !important;
    .settingstitle {
      display: none;
    }
    .edit-invoice-design-wrap .right-col {
      margin-bottom: 75px;
    }
  }
</style>

<style lang="scss" scoped>
  .mobile-layout-design {
    background: white;
  }
</style>
